/* datas */
import { GetYear } from '../Functions/GetDates.js';
import { GetBkgLogo } from '../Functions/GetBkgLogo.js';
/* document */
import { LogoCharacter } from '../../../Files/LogoCharacter.js';
import { BlockRencontre } from '../Blocks/BlockRencontre.js';
import { BlockLink } from '../Blocks/BlockLink.js';

export const BlockLogoCharacters = (props) => {
    const { label, item } = props;
    const enable = item.catslug;
    const bkg = enable === 'rendez-vous' ? GetBkgLogo(item.pslug) : '';
    const src = LogoCharacter(item.oslug, item.cslug);
    let created, name, link1, link2;
    switch (label) {
        case 'characters':
        case 'character':
        case 'family':
        case 'origin':
        case 'rendez-vous-personnage':
            name = item.cname;
            created = GetYear(item.ccreated);
            if (label === 'characters') {
                link1 = { name: item.fname, href: item.froute };
                link2 = { name: item.oname, href: item.oroute };
            }
            if (label === 'character' || label === 'family') {
                let nameCha = enable === 'rendez-vous' ? 'Rendez-vous' : 'Personnages';
                let hrefCha = enable === 'rendez-vous' ? '/rendez-vous' : '/personnages';
                link1 = { name: nameCha, href: hrefCha };
                link2 = { name: item.oname, href: item.oroute };
            }
            if (label === 'origin') {
                link1 = { name: item.fname, href: item.froute };
                link2 = { name: item.oname, href: item.oroute };
            }
            if (label === 'rendez-vous-personnage') {
                link1 = { name: item.fname, href: item.froute };
                link2 = { name: item.oname, href: item.oroute };
            }
            return (
                <div className={`logo ${bkg}`}>
                    <BlockRencontre enable={enable} bkg={bkg} />
                    <a className="icon" href={item.croute} alt={name} title={name}>
                        <img className="img" src={src} title={name} alt={name} loading="lazy" />
                    </a>
                    <div className="legend">
                        <div className="title">{name}</div>
                        <div className="block-created">
                            <div className="created">{created}</div>
                        </div>
                        <BlockLink label="link-true" href={link1.href} name={link1.name} />
                        <BlockLink label="link-date" href={link2.href} name={link2.name} />
                    </div>
                </div>
            )
        default:
            return (
                <></>
            )
    }
}